/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CognitoResetPasswordResponseDto,
  CognitoStatusDto,
} from '../models/index';
import {
    CognitoResetPasswordResponseDtoFromJSON,
    CognitoResetPasswordResponseDtoToJSON,
    CognitoStatusDtoFromJSON,
    CognitoStatusDtoToJSON,
} from '../models/index';

export interface DisableUserRequest {
    userId: string;
}

export interface EnableUserRequest {
    userId: string;
}

export interface GetCognitoStatusRequest {
    userId: string;
}

export interface ResetUserPasswordRequest {
    userId: string;
}

export interface SignOutUserRequest {
    userId: string;
}

/**
 * 
 */
export class CognitoAuthenticationServiceApi extends runtime.BaseAPI {

    /**
     * Disable the retailer user in Cognito — blocks login.
     */
    async disableUserRaw(requestParameters: DisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoResetPasswordResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling disableUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/auth/disable/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoResetPasswordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Disable the retailer user in Cognito — blocks login.
     */
    async disableUser(requestParameters: DisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoResetPasswordResponseDto> {
        const response = await this.disableUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-enable a previously disabled Cognito user.
     */
    async enableUserRaw(requestParameters: EnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoResetPasswordResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling enableUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/auth/enable/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoResetPasswordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Re-enable a previously disabled Cognito user.
     */
    async enableUser(requestParameters: EnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoResetPasswordResponseDto> {
        const response = await this.enableUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Cognito account status for a retailer user
     */
    async getCognitoStatusRaw(requestParameters: GetCognitoStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoStatusDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getCognitoStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/auth/cognito-status/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoStatusDtoFromJSON(jsonValue));
    }

    /**
     * Get Cognito account status for a retailer user
     */
    async getCognitoStatus(requestParameters: GetCognitoStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoStatusDto> {
        const response = await this.getCognitoStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger a Cognito password reset for a retailer user. The user will be required to set a new password on next login via the standard reset flow.
     */
    async resetUserPasswordRaw(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoResetPasswordResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling resetUserPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/auth/reset-password/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoResetPasswordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Trigger a Cognito password reset for a retailer user. The user will be required to set a new password on next login via the standard reset flow.
     */
    async resetUserPassword(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoResetPasswordResponseDto> {
        const response = await this.resetUserPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sign the retailer user out of Cognito globally — invalidates all refresh tokens so the user must re-authenticate.
     */
    async signOutUserRaw(requestParameters: SignOutUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoResetPasswordResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling signOutUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/auth/sign-out/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoResetPasswordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Sign the retailer user out of Cognito globally — invalidates all refresh tokens so the user must re-authenticate.
     */
    async signOutUser(requestParameters: SignOutUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoResetPasswordResponseDto> {
        const response = await this.signOutUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
